import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins} from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import { useAppState } from 'components/contexts/State';
import htmlForFeature from 'utils/htmlForFeature';
import getPinnedTooltipCoordinate from 'utils/getPinnedTooltipCoordinate';
 
export const SYSTEMICINTERSECTION_LAYER_ID = 'systemicIntersectionLayer';
 
export const CATEGORY_COLORS = {
  Parcel: [0, 100, 214],
};
 
const layerConfig = {
  title: 'Systemic Score Intersections',
};
 
function SystemicIntersectionLayer() {
  const dispatch = useDispatch();
  const { systemicIntersectionLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>  selectSourceById(state, systemicIntersectionLayer?.source));
 
  const cartoLayerProps = useCartoLayerProps({ source });
  const {pinnedTooltip, setPinnedTooltip} = useAppState();
  const viewState = useSelector((state) => state.carto.viewState);
  const pointRadiusMinPixels = viewState.zoom >= 7 ? 4 : 2;
 
  if (systemicIntersectionLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: SYSTEMICINTERSECTION_LAYER_ID,
 
      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: systemicIntersectionLayer.visible,
      opacity: systemicIntersectionLayer.opacity,
      getFillColor: colorBins({
        attr: 'Systemic_Score',
        domain: [ 2, 4, 6, 8, 9],
       colors: [
          [145, 53, 125, 51],
          [145, 53, 125, 102],
          [145, 53, 125, 153],
          [145, 53, 125, 204],
          [145, 53, 125, 255],
        ],
      }),
      pointRadiusMinPixels: pointRadiusMinPixels,
 
      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: SYSTEMICINTERSECTION_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad?.(data);
      },
 
      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
            }),
          };
        }
      },
      onClick: (info) => {
        if (info?.object) {
          const html = htmlForFeature({ feature: info.object });
          if (pinnedTooltip?.html === html) {
            setPinnedTooltip(null);
          } else {
            setPinnedTooltip({
              html,
               postMileInfo: info.object.properties,
              coordinate: getPinnedTooltipCoordinate(info),
            });
          }
        }
      },
    });
  }
}
 
export default SystemicIntersectionLayer;